import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import { get } from 'global/lib/lodash';
import { getColorFromScore } from 'global/styles';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { filterData } from '../AssessmentScore';
import { useLoaded } from 'global/hooks/useLoaded';
import { PScoreIncludes } from '../Assessment/ReportAssessment';

const ScoreRow = (props) => {
  const { title, score, displayScore } = props;
  const classes = useStyles();

  let val = parseFloat(typeof score === 'string' ? score.replace('%', '') : score);

  return (
    <div className={classes.scoreRow}>
      <div className={classes.scoreTitle}>{title}</div>
      <div className={classes.box}>
        <div className={classes.boxBg} style={{ width: `${val}%`, backgroundColor: getColorFromScore(val) }} />
      </div>
      <div className={classes.scoreValue}>{displayScore}</div>
    </div>
  );
};

const ScoreCard = (props) => {
  const { assessment, scorecard, scores, scorecardIndex } = props;
  const [systems, setsystems] = useState([]);
  const classes = useStyles();

  const assessment_id = get(assessment, 'data.id', null);

  const { data, loading } = scores;

  const loadProcessed = async () => {
    if (!loading) {
      const s = data[scorecard.id]?.filter((d) => d.depth < 2);
      setsystems(s);
    }
  };

  useEffect(() => {
    loadProcessed();
  }, [data, loading]);

  return (
    <div className={classes.scorecardWrap}>
      <div className={classes.scorecardTitle}>{get(scorecard, 'name')}</div>

      <ScoreRow title={`Overall`} score={get(systems, '0.value')} displayScore={get(systems, '0.displayScore')} />

      {systems.filter((d) => d.depth === 1 && d.value !== null).map((sc, i) => (
        <ScoreRow key={i} title={sc.name} displayScore={sc.displayScore || sc.value} score={sc.value || sc.displayScore} />
      ))}
    </div>
  );
};

export default (props) => {
  const { assessment, canShowScores, scores } = props;
  const classes = useStyles();

  const cards = get(assessment, 'data.scorecards', []);

  useLoaded(props, [!cards]);

  return !canShowScores ? null : (
    <div className={classes.container}>
      <div className={classes.title}>Scorecard Summary</div>

      {cards.map((card, i) => (
        <ScoreCard key={i} scorecard={card} scores={scores} scorecardIndex={i} assessment={assessment} />
      ))}
    </div>
  );
};
